export const gaEventTrigger = async (pageTitle: string, action: string) => {
    gtag('event', 'coming soon', {
        'page_title': pageTitle || "Untitled Page",
        'action': action || "Untitled Action",
    });
}

export const authErrorHandler = (error: any) => {
    if (error.message === "Authentication failed"|| error.message.toLowerCase().includes("unauthorized")) {
        console.error("Authentication failed. Please log in again.");
    } else {
        console.error("An unexpected error occurred:", error);
    }
}